import apiClient from "./apiClient"; // Asegúrate de que la ruta es correcta

const marketingCampaignsEndpoint = "/marketingCampaigns";

// --- Funciones refactorizadas ---

export const getAllMarketingCampaigns = async () =>
  apiClient.get(marketingCampaignsEndpoint).then((res) => res.data);

export const filterByTags = async (selectedTags) => {
  try {
    const tagsParam = selectedTags.map((tag) => tag._id).join(","); // Crear un string con los _id de los tags seleccionados
    const res = await apiClient.get(
      `${marketingCampaignsEndpoint}/filterByTags?tags=${tagsParam}`,
    );
    return res.data;
  } catch (error) {
    console.error("Error fetching campaigns by tags:", error);
    throw error;
  }
};

export const createMarketingCampaign = (payload) => {
  return apiClient
    .post(`${marketingCampaignsEndpoint}/create`, payload) // payload es un JSON ahora
    .then((res) => res.data);
};

export const updateMarketingCampaign = async (payload, catalogId) => {
  return apiClient
    .put(`${marketingCampaignsEndpoint}/edit/${catalogId}`, payload)
    .then((res) => res.data);
};

export const sendMarketingCampaign = async (data) => {
  // Aquí 'data' es un objeto JSON.
  return apiClient
    .post(`${marketingCampaignsEndpoint}/sendEmail`, data)
    .then((res) => res.data);
};

export const getMarketingCampaignSendStatus = async (sendId) => {
  return apiClient
    .get(`${marketingCampaignsEndpoint}/sendStatus/${sendId}`)
    .then((res) => res.data);
};

export const updateCategoryHomeImage = async (form, imageName, catalogId) => {
  return apiClient
    .put(
      `${marketingCampaignsEndpoint}/home/categories/${imageName}/edit/${catalogId}`,
      form,
    )
    .then((res) => res.data);
};

export const updateHomeTextAndImage = async (form, catalogId) => {
  return apiClient
    .put(`${marketingCampaignsEndpoint}/home/edit/${catalogId}`, form)
    .then((res) => res.data);
};

export const updateHomeServicesTextAndImage = async (
  form,
  imageName,
  dataId,
) => {
  return apiClient
    .put(`${marketingCampaignsEndpoint}/home/${imageName}/edit/${dataId}`, form)
    .then((res) => res.data);
};

export const updateContactHome = async (form, dataId) => {
  return apiClient
    .put(`${marketingCampaignsEndpoint}/home/talkwhitus/edit/${dataId}`, form)
    .then((res) => res.data);
};

export const deleteMarketingCampaign = async (id, campaignImage) => {
  return apiClient
    .delete(`${marketingCampaignsEndpoint}/delete/${id}`, {
      data: campaignImage,
    })
    .then((res) => res.data);
};

export const updateServicesTextAndImage = async (form, imageName, dataId) => {
  // Mantenemos la lógica interna de la función.
  let urlService;
  if (imageName === "interiorimsImage") urlService = "interiorism";
  else if (imageName === "developmentImage") urlService = "development";

  return apiClient
    .put(
      `${marketingCampaignsEndpoint}/services/${urlService}/edit/${dataId}`,
      form,
    )
    .then((res) => res.data);
};
